const sx = {
	wrap({ isDragActive, isDragReject, error } = {}) {
		return {
			...(isDragActive && { opacity: 0.72 }),
			...((isDragReject || error) && {
				color: 'error.main',
				borderColor: 'error.light',
				bgcolor: 'error.lighter',
			}),
			height: 134,
		};
	},
	fileIcon() {
		return {
			width: 80,
			height: 80,
			objectFit: 'contain',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			color: 'secondary',
			fontSize: '1.5rem',
		};
	},
};

export default sx;
